<template>
  <div class="layout-container-box">
    <el-header class="layout-header">
      <Header>
        <template #header-brand>
          <BreadCrumb :breadList="breadLists" />
        </template>
      </Header>
    </el-header>
    <el-scrollbar class="layout-main-content" id="content_box">
      <div class="pd-20">
        <div class="create-person-container">
          <el-card class="mg-b-16">
            <template #header>
              <div class="card-header">
                <span class="card-name">投资事件基本信息</span>
              </div>
            </template>
            <div class="form-container">
              <el-form
                ref="formRef"
                :model="investForm"
                :rules="investFormRule"
                label-width="120px"
                class="user-form-box mg-t-24"
              >
                <el-form-item label="主体名称" prop="company_name">
                  <el-input
                    style="width: 400px"
                    v-model="investForm.company_name"
                    placeholder="请选择"
                    @click="showDialog('company', '选择主体')"
                  ></el-input>
                </el-form-item>
                <el-form-item label="轮次" prop="round">
                  <el-select
                    style="width: 400px"
                    placeholder="请选择"
                    v-model="investForm.round"
                    @change="roundChange"
                  >
                    <el-option
                      :label="item.name"
                      :value="item.id"
                      v-for="item in roundData"
                      :key="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="金额" prop="no_amount">
                  <el-input
                    style="width: 400px"
                    v-model="investForm.no_amount"
                    placeholder="请输入"
                    :disabled="investForm.is_accurate"
                  />
                  <el-input
                    v-model="investForm.amount"
                    class="mg-l-32 mg-r-12"
                    style="width: 100px"
                    placeholder="请输入"
                    @input="(e) => (investForm.amount = Rule.inputNum(e))"
                    :disabled="!investForm.is_accurate"
                  />
                  <el-select
                    class="mg-r-12"
                    style="width: 100px"
                    v-model="investForm.amount_unit"
                    @input="(e) => (investForm.amount = Rule.inputNum(e))"
                    :disabled="!investForm.is_accurate"
                  >
                    <el-option
                      v-for="item in moneyUnits"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-checkbox
                    v-model="investForm.is_accurate"
                    label="准确"
                    @change="accurateChange"
                  ></el-checkbox>
                </el-form-item>
                <el-form-item label="时间" prop="finace_time">
                  <el-date-picker
                    style="width: 400px"
                    v-model="investForm.finace_time"
                    type="date"
                    placeholder="选择日期"
                    :value-format="'YYYY-MM-DD'"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="投资方" prop="investorobj">
                  <el-tag
                    class="mg-r-12"
                    v-for="(item, index) in investForm.investorobj"
                    :key="item.id"
                    closable
                    :disable-transitions="false"
                    @close="deleteInvestor(index)"
                  >
                    {{ item.name }}
                  </el-tag>
                  <el-button
                    size="small"
                    @click="showDialog('investor', '选择投资方')"
                    >+ 新标签</el-button
                  >
                </el-form-item>
                <el-form-item
                  label="最大估值"
                  class="mg-t-12"
                  prop="no_appraise"
                >
                  <el-input
                    style="width: 400px"
                    placeholder="请输入"
                    v-model="investForm.no_appraise"
                    :disabled="investForm.is_accurate_app"
                  ></el-input>
                  <el-input
                    v-model="investForm.appraise"
                    class="mg-l-32 mg-r-12"
                    style="width: 100px"
                    placeholder="请输入"
                    @input="(e) => (investForm.appraise = Rule.inputNum(e))"
                    :disabled="!investForm.is_accurate_app"
                  />
                  <el-select
                    class="mg-r-12"
                    style="width: 100px"
                    v-model="investForm.appraise_unit"
                    :disabled="!investForm.is_accurate_app"
                  >
                    <el-option
                      v-for="item in moneyUnits"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-checkbox
                    v-model="investForm.is_accurate_app"
                    label="准确"
                    @change="accurateAppChange"
                  ></el-checkbox>
                </el-form-item>
              </el-form>
            </div>
          </el-card>
          <div class="bottom-submit-box pd-16 mg-t-24">
            <el-row justify="end">
              <el-col :span="24" class="text-right">
                <el-button plain type="primary" @click="cancelSubmit('formRef')"
                  >取消</el-button
                >
                <el-button type="primary" @click="submitForm('formRef')"
                  >保存</el-button
                >
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </el-scrollbar>
    <el-dialog
    v-model="tagDialogShow"
    :title="dialogDetail.title"
    :width="880"
    :close-on-click-modal="false"
    :show-close="true"
  >
    <div class="dialog-content">
      <el-input
        style="width: 200px"
        v-model="searchForm.name"
        placeholder="请输入"
        :suffix-icon="Search"
        @change="submit"
      ></el-input>
      <el-table
        v-loading="isLoading"
        class="mg-t-12"
        :data="dialogTable"
        border
        max-height="400"
      >
        <el-table-column prop="name" label="名称">
          <template #default="scope">
            <el-input
              v-if="scope.row.status == 'new'"
              v-model="scope.row.name"
              placeholder="请输入"
            ></el-input>
            <span v-else>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="type"
          label="类型"
          v-if="dialogDetail.type == 'investor'"
        >
          <template #default="scope">
            <div v-if="scope.row.status == 'new'">
              <el-select
                class="mg-r-12"
                style="width: 100px"
                v-model="scope.row.unit_type"
              >
                <el-option label="机构" :value="1"></el-option>
                <el-option label="主体" :value="2"></el-option>
              </el-select>
            </div>
            <div v-else>
              <span v-if="scope.row.type == 'com'">主体</span>
              <span v-else-if="scope.row.type == 'org'">机构</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="operation" label="操作">
          <template #default="scope">
            <el-radio
              v-if="dialogDetail.type == 'company'"
              v-model="companyId"
              :label="scope.row.id"
              @change="companyChange"
              >选择</el-radio
            >
            <el-checkbox
              v-else
              v-model="investors"
              :label="scope.row.id"
              @change="(status) => investorChange(scope.row.id, status)"
              >选择</el-checkbox
            >
          </template>
        </el-table-column>
        <template #empty>
          没有匹配的结果
        </template>
      </el-table>
      <div class="table-pagination-row mg-t-24">
        <el-pagination
          v-if="dialogDetail.type == 'company'"
          background
          :currentPage="paginationData.current"
          :page-sizes="paginationData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="paginationData.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <template #footer>
      <el-button plain type="primary" @click="tagDialogShow = false"
        >取消</el-button
      >
      <el-button type="primary" @click="submit()">确定</el-button>
    </template>
  </el-dialog>
  </div>


  <!-- </Layout> -->
</template>

<script>
import { ref, onMounted, getCurrentInstance } from "vue";
import { useRouter, useRoute, isNavigationFailure } from "vue-router";
import { Ajax, MessageTips, Rule } from "../../../../utils";
import { Search } from "@element-plus/icons-vue";
import Header from "../../../../Layout/components/Header.vue";
import BreadCrumb from "../../../../components/BreadCrumb/index.vue";
export default {
  components: {
    Header,
    BreadCrumb,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const breadLists = ref([
      {
        name: "投资事件",
        path: {
          name: "InvestEvent",
        },
      },
      {
        name: "投资事件详情",
        path: {
          name: "InvestEventDetail",
          query: {
            id: route.query.id,
          },
        },
      },
      {
        name: "编辑投资事件",
      },
    ]);
    const isLoading = ref(false);
    const { proxy } = getCurrentInstance();
    const dialogDetail = ref({
      title: undefined,
      type: undefined,
    });
    const searchForm = ref({
      page: 1,
      page_size: 10,
      name: undefined,
    });
    const roundName = ref();
    const dialogTable = ref([]);
    const companyId = ref();
    const companyObj = ref({});
    const companyChange = (id) => {
      if (!id) {
        Ajax.POST({
          url: "/admin/personage/add_unit",
          data: {
            name: dialogTable.value[0].name,
            unit_type: 2,
          },
        }).then((res) => {
          if (res.data.code == 200) {
            dialogTable.value[0].id = res.data.data.insertId;
            companyId.value = res.data.data.insertId;
          } else {
            MessageTips.error(res.data.msg);
            return;
          }
        });
      }
      for (let i in dialogTable.value) {
        let item = dialogTable.value[i];
        if (item.id == companyId.value) {
          console.log(item);
          companyObj.value = item;
        }
      }
    };
    const investors = ref([]);
    const paginationData = ref({
      current: 1,
      pageSize: [10, 20, 50],
      total: 0,
    });
    const handleSizeChange = (e) => {
      searchForm.value.page_size = e;
      if (dialogDetail.value.type == "company") {
        getCompany("search");
      }
    };
    const handleCurrentChange = (e) => {
      paginationData.value.current = e;
      searchForm.value.page = e;
      if (dialogDetail.value.type == "company") {
        getCompany();
      }
    };
    const investFormRef = ref({
      company_id: undefined,
      company_name: undefined,
      round: undefined,
      amount: undefined,
      finace_time: undefined,
      investor: [],
      investorobj: [],
      company: [],
      company_ids: [],
      appraise: undefined,
      no_appraise: undefined,
      appraise_unit: undefined,
      amount_unit: undefined,
      is_accurate: undefined,
      is_accurate_app: undefined,
      no_amount: undefined,
    });
    const investorobj = ref([]);
    const investorChange = (id, status) => {
      if (!id && status) {
        let index = investors.value.indexOf(id);
        if (!dialogTable.value[0].name) {
          investors.value.splice(index, 1);
          MessageTips.error("请输入名称");
          return;
        }
        if (!dialogTable.value[0].unit_type) {
          investors.value.splice(index, 1);
          MessageTips.error("请选择类型");
          return;
        }
        Ajax.POST({
          url: "/admin/personage/add_unit",
          data: {
            name: dialogTable.value[0].name,
            unit_type: dialogTable.value[0].unit_type,
          },
        }).then((res) => {
          if (res.data.code == 200) {
            dialogTable.value[0].id = res.data.data.insertId;
            dialogTable.value[0].status = undefined;
            dialogTable.value[0].type =
              dialogTable.value[0].unit_type == 1 ? "org" : "com";
            investors.value.push(res.data.data.insertId);
          } else {
            MessageTips.error(res.data.msg);
            investors.value.splice(index, 1);
            return;
          }
        });
      }
       if (status) {
        for (let i in dialogTable.value) {
          let item = dialogTable.value[i];
          if (item.id == id) {
            investorobj.value.push(item);
            break;
          }
        }
      } else {
        for (let i in investorobj.value) {
          let item = investorobj.value[i];
          if (item.id == id) {
            investorobj.value.splice(i, 1);
            break;
          }
        }
      }
    };
    const deleteInvestor = (index) => {
      investors.value.splice(index, 1);
      investFormRef.value.investorobj.splice(index, 1);
    };
    const cancelSubmit = (formName) => {
      // proxy.$refs[formName].resetFields();
      router.back();
    };
    const submitForm = (formName) => {
      proxy.$refs[formName].validate((valid) => {
        if (valid) {
          console.log("submit");
          investFormRef.value.investor = [];
          investFormRef.value.company_ids = [];
          for (let i in investFormRef.value.investorobj) {
            let item = investFormRef.value.investorobj[i];
            if (item.type == "com") {
              investFormRef.value.company_ids.push(item.id);
            } else {
              investFormRef.value.investor.push(item.id);
            }
          }
          console.log(investFormRef.value);
          Ajax.POST({
            url: `/admin/invest/update/${investFormRef.value.id}`,
            data: {
              company_id: investFormRef.value.company_id,
              round: investFormRef.value.round,
              amount: +investFormRef.value.amount,
              finace_time: investFormRef.value.finace_time,
              investor: investFormRef.value.investor,
              company_ids: investFormRef.value.company_ids,
              appraise: +investFormRef.value.appraise,
              no_appraise: investFormRef.value.no_appraise,
              appraise_unit: investFormRef.value.appraise_unit,
              amount_unit: investFormRef.value.amount_unit,
              is_accurate: investFormRef.value.is_accurate ? 1 : 2,
              is_accurate_app: investFormRef.value.is_accurate_app ? 1 : 2,
              no_amount: investFormRef.value.no_amount,
            },
          }).then((res) => {
            if (res.data.code == 200) {
              MessageTips.success("编辑成功");
              router.back();
            } else {
              MessageTips.error(res.data.msg);
            }
          });
        } else {
          console.log("error");
          return;
        }
      });
    };
    const investFormRule = {
      company_name: [
        {
          required: true,
          message: "请选择",
          trigger: "blur",
        },
      ],
      round: [
        {
          required: true,
          message: "请选择",
          trigger: "change",
        },
      ],
      no_amount: [
        {
          required: true,
          validator: (rule, value, callback) => {
            if (!investFormRef.value.no_amount&&!investFormRef.value.amount) {
              callback(new Error("请输入"));
            } else {
                callback();
            }
          },
          trigger: "blur",
        },
      ],
      finace_time: [
        {
          required: true,
          message: "请选择",
          trigger: "blur",
        },
      ],
      investorobj: [
        {
          required: true,
          message: "请添加",
          trigger: "blur",
        },
      ],
      no_appraise: [
        {
          required: false,
          message: "请输入",
          trigger: "blur",
        },
      ],
    };
    const tagDialogShowRef = ref(false);
    //获取主体
    const getCompany = (type) => {
      isLoading.value = true;
      if (type) {
        searchForm.value.page = 1;
        paginationData.value.current = 1;
      }
      Ajax.GET({
        url: "/admin/company",
        params: searchForm.value,
      }).then((res) => {
        isLoading.value = false;
        dialogTable.value = res.data.data.list;
        paginationData.value.total = res.data.data.page_info.total;
      });
    };
    const addCompany = () => {
      dialogTable.value[0] = {
        status: "new",
        name: searchForm.value.name,
        id: 0,
      };
      paginationData.value.total = 1;
    };
    const roundData = ref([]);
    //获取轮次
    const getRound = () => {
      Ajax.POST({
        url: "/admin/invest/rounds",
      }).then((res) => {
        roundData.value = res.data.data;
      });
    };

    //获取投资方
    const getInvestors = (type) => {
      isLoading.value = true;
      if (type) {
        searchForm.value.page = 1;
        paginationData.value.current = 1;
        dialogTable.value = [];
      }
      Ajax.POST({
        url: "/admin/invest/invest",
        data: {
          name: searchForm.value.name,
        },
      }).then((res) => {
        isLoading.value = false;
        if (res.data.code == 200) {
          let com = ref(res.data.data.com);
          let org = ref(res.data.data.org);
          for (let i in com.value) {
            let item = com.value[i];
            item.type = "com";
            dialogTable.value.push(item);
          }
          for (let i in org.value) {
            let item = org.value[i];
            item.type = "org";
            dialogTable.value.push(item);
          }
          console.log(dialogTable.value);
        } else {
          MessageTips.error(res.data.msg);
        }

        // dialogTable.value = res.data.data.list;
      });
    };
    const roundChange = (round) => {
      console.log(round, roundName.value);
    };
    const showDialog = (type, title) => {
      dialogDetail.value.type = type;
      dialogDetail.value.title = title;
      searchForm.value.page = 1;
      searchForm.value.name = undefined;
      paginationData.value.total = 0;
      paginationData.value.current = 1;
      dialogTable.value = [];
      if (type == "company") {
        getCompany();
      } else {
        investors.value = [];
        investorobj.value = [];
        for (let i in investFormRef.value.investorobj) {
          let item = investFormRef.value.investorobj[i];
          investors.value.push(item.id);
          investorobj.value.push(item);
        }
      }
      tagDialogShowRef.value = true;
    };
    const submit = (type) => {
      if (type) {
        if (dialogDetail.value.type == "company") {
          getCompany("search");
        } else {
          getInvestors("search");
        }
      } else {
        tagDialogShowRef.value = false;
        if (dialogDetail.value.type == "company") {
          investFormRef.value.company_id = companyId.value;
          investFormRef.value.company_name = companyObj.value.name;
        } else {
          investFormRef.value.investorobj = [];
          for (let i in investorobj.value) {
            let item = investorobj.value[i];
            investFormRef.value.investorobj.push(item);
          }
        }
      }
    };
    const getDetail = (id) => {
      Ajax.POST({
        url: `/admin/invest/details/${id}`,
      }).then((res) => {
        if (res.data.code == 200) {
          investFormRef.value.id = res.data.data.id;
          investFormRef.value.company_id = res.data.data.company_id;
          investFormRef.value.company_name = res.data.data.company_name;
          investFormRef.value.round = res.data.data.round_id;
          investFormRef.value.amount = res.data.data.amount;
          investFormRef.value.finace_time = res.data.data.finace_time;
          investFormRef.value.appraise = res.data.data.appraise;
          investFormRef.value.no_appraise = res.data.data.no_appraise;
          investFormRef.value.amount_unit = res.data.data.amount_unit?res.data.data.amount_unit:undefined;
          investFormRef.value.appraise_unit = res.data.data.appraise_unit?res.data.data.appraise_unit:undefined;
          investFormRef.value.is_accurate =
            res.data.data.is_accurate == 1 ? true : false;
          investFormRef.value.is_accurate_app =
            res.data.data.is_accurate_app == 1 ? true : false;
          investFormRef.value.no_amount = res.data.data.no_amount;
          for (let i in res.data.data.investor_arr_info) {
            let item = res.data.data.investor_arr_info[i];
            item.type = "org";
            investFormRef.value.investorobj.push(item);
          }
          for (let i in res.data.data.company_arr_info) {
            let item = res.data.data.company_arr_info[i];
            item.type = "com";
            investFormRef.value.investorobj.push(item);
          }
        }
      });
    };
    const moneyUnits = ref([]);
    const getUnit = () => {
      Ajax.POST({
        url: "/admin/unit",
      }).then((res) => {
        moneyUnits.value = res.data.data;
      });
    };
    const accurateChange=()=>{
      if(investFormRef.value.is_accurate){
        investFormRef.value.no_amount=undefined
      }else{
        investFormRef.value.amount=undefined
        investFormRef.value.amount_unit=undefined
      }
    }
    const accurateAppChange=()=>{
      if(investFormRef.value.is_accurate_app){
        investFormRef.value.no_appraise=undefined
      }else{
        investFormRef.value.appraise=undefined
        investFormRef.value.appraise_unit=undefined
      }
    }
    onMounted(() => {
      getUnit();
      getRound();
      let id = route.query.id;
      getDetail(id);
    });
    return {
      breadLists,
      investForm: investFormRef,
      cancelSubmit,
      submitForm,
      investFormRule,
      tagDialogShow: tagDialogShowRef,
      dialogDetail,
      showDialog,
      searchForm,
      dialogTable,
      companyId,
      companyChange,
      isLoading,
      paginationData,
      handleSizeChange,
      handleCurrentChange,
      getCompany,
      addCompany,
      Search,
      submit,
      roundData,
      roundName,
      roundChange,
      investors,
      investorChange,
      deleteInvestor,
      Rule,
      moneyUnits,
      accurateChange,
      accurateAppChange
    };
  },
};
</script>

<style lang="less" scoped>
.create-person-container {
  height: 100%;
  .write-box {
    background-color: #fff;
  }
  .user-form-box {
    .info-img {
      width: 200px;
      height: 200px;
    }
  }
  .bottom-submit-box {
    background-color: #fff;
  }
  .form-container {
    height: 100%;
  }
}
</style>
